var app = angular.module('omega', [
    'ui.router',
    'xml',
    'officeuifabric.core',
    'officeuifabric.components',
    'pascalprecht.translate',
    'rzModule',
    'LocalStorageModule',
    'wu.masonry',
    'chart.js'
]);

/*
 * Events broadcasted
 * "enterBrowserHistoryState" = when user is entering a state previously visited (usually with browser back/next buttons)
 * "initializeSearchData" = when search is initialized or re-initialized
 * "search" = when search is launched by user
 * "searchDataStoredInHistory" = during a search, when we save the query in History
 * "conceptListPromiseSuccessful" = when we have response for concept list on search
 * "resourceListPromiseSuccessful" = when we have response for resources (normal) on search
 * "reCalcViewDimensions" (related to angular-slider package) = we broadcast this event manually to calculate slider dimensions (used for tab panes)
 * "keydown" = fired by "keytrap" directive when user presses a key
 * "settingsReceived" = fired when we receive user settings from API (app.run)
 */

// app settings
app.constant('ENV', __env.environment);
app.constant('BASE_URL', __env.baseUrl);
app.constant('API_BASE_URL', __env.apiBaseUrl);
app.constant('IMAGE_SERVER_BASE_URL', __env.imageServerBaseUrl);
app.constant('AUTH_SERVER_URL', __env.authServerUrl);
app.constant('DIRECTORY_URL', __env.directoryUrl);
app.constant('LINK_SERVER_URL', __env.linkServerUrl);
app.constant('DEFAULT_LANGUAGE', 'EN');
app.constant('DEFAULT_MASONRY_MODE', false);
app.constant('DEFAULT_PRECISION', 1);
app.constant('DEFAULT_SHOW_SIDEBAR', false);
app.constant('SHOW_DICTIONARY', __env.showDictionary);
app.constant('DEFAULT_SEARCH_PROFILE', 'generic');
app.constant('DEFAULT_DATE_FROM', null);
app.constant('DEFAULT_DATE_TO', null);
app.constant('RESOURCES_PER_PAGE', 10);
app.constant('MAX_SUGGESTED_CONCEPTS', 25);
app.constant('MAX_CONCEPTS_FOR_FAST_DISCOVERY_REQUEST', 10);
app.constant('HISTORY_SEARCHES', 5);
app.constant('MAX_SAVED_SEARCHES', 50);
app.constant('MAX_SAVED_RESOURCES', 100);
app.constant('FLASH_MESSAGES_DURATION', 4000);
app.constant('MAX_RECOMMENDED_RESULTS', 2000);
app.constant('MIN_WORD_LENGTH_FOR_SUGGESTIONS', 4);
app.constant('DISPLAYABLE_TAGS', ['http://kim.oecd.org/Taxonomy/Topics#', 'http://kim.oecd.org/Taxonomy/GeographicalAreas#', 'http://kim.oecd.org/Taxonomy/Organisations#', 'http://innovation.oecd.org/taxonomy/topics#']);
app.constant('MAX_ITEMS_IN_NON_EXPANDED_CHARTS', 8);

// app configuration
app.config(function ($stateProvider, $httpProvider, $locationProvider, $urlRouterProvider, localStorageServiceProvider) {

    // routing
    $stateProvider
        .state("search",
            {
                url: "/?q?id?mode?uri?searchProfileId",
                templateUrl: "templates/master.html",
                reloadOnSearch: false,
                controller: "MainCtrl"
            }
        );

    // client-side XML to JSON decoder configuration
    $httpProvider.interceptors.push('xmlHttpInterceptor');

    // Default POST requests headers
    $httpProvider.defaults.headers.post['Content-Type'] = undefined;

    // use the HTML5 History API and use html5 mode to remove # in URL
    $locationProvider.html5Mode(true);

    // Send to 404 if unmatched URL
    $urlRouterProvider.otherwise('404');

    // avoid overwriting any local storage variables
    localStorageServiceProvider
        .setPrefix('omega')
        .setStorageType('localStorage');

});

// executes on app start up (after config)
app.run(function ($rootScope, $state, $translate, DEFAULT_LANGUAGE, RESOURCES_PER_PAGE, LINK_SERVER_URL, SettingsService, AuthService) {

    AuthService.getUser().then(function (username) {

        $rootScope.username = username;

        // user or default settings
        SettingsService.list().then(function (settings) {
            $rootScope.lang = settings && settings.lang ? settings.lang : DEFAULT_LANGUAGE;
            $translate.use($rootScope.lang);
            $rootScope.resourcesPerPage = settings && settings.resourcesPerPage ? settings.resourcesPerPage : RESOURCES_PER_PAGE.toString();

            $rootScope.linkServerUrl = LINK_SERVER_URL;
            $rootScope.settings = settings ? settings : {};

            $rootScope.$broadcast('settingsReceived');
        });

    }, function () {
        // in case we can't connect
        // TODO : this code is not DRY, check how to execute those lines in both cases (promise fulfilled OR rejected)
        SettingsService.list().then(function (settings) {
            $rootScope.lang = settings && settings.lang ? settings.lang : DEFAULT_LANGUAGE;
            $translate.use($rootScope.lang);
            $rootScope.resourcesPerPage = settings && settings.resourcesPerPage ? settings.resourcesPerPage : RESOURCES_PER_PAGE.toString();

            $rootScope.linkServerUrl = LINK_SERVER_URL;
            $rootScope.settings = settings ? settings : {};

            $rootScope.$broadcast('settingsReceived');
        });
    });

    /*
     to allow browser back/next buttons navigation (reload search on known locations) we detect when we are in
     a state that we already know and broadcast event.
     */
    var browserHistory = [];
    $rootScope.$on('$locationChangeSuccess', function () {
        if (browserHistory.indexOf($state.params.id) !== -1) {
            // been here before
            $rootScope.$broadcast('enterBrowserHistoryState');
        } else {
            browserHistory.push($state.params.id);
        }
    });

});
